import { useState, useEffect } from 'react';
import { testimonials } from '../../../mocks/testimonials';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const current = testimonials[currentIndex];

  return (
    <section id="testimonials" className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <span className="inline-block text-xs font-display font-semibold uppercase tracking-[3px] text-sage-500 mb-2 sm:mb-3">
            Testimonials
          </span>
          <h3 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-gray-900 tracking-tight">
            What Brands Say
          </h3>
        </div>

        <div className="max-w-3xl mx-auto text-center">
          {/* Large quote icon */}
          <div className="text-5xl sm:text-7xl font-serif text-sage-300 mb-4 sm:mb-6 leading-none">&ldquo;</div>

          {/* Quote */}
          <p className="text-lg sm:text-xl lg:text-2xl text-gray-700 leading-relaxed mb-8 sm:mb-10 font-sans font-light italic px-4">
            {current.quote}
          </p>

          {/* Divider */}
          <div className="w-10 sm:w-12 h-[2px] bg-sage-400 mx-auto mb-5 sm:mb-6"></div>

          {/* Name & Role */}
          <h4 className="text-base sm:text-lg font-display font-semibold text-gray-900 mb-1">
            {current.name}
          </h4>
          <p className="text-xs sm:text-sm font-sans text-gray-500">{current.role}</p>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2 mt-8 sm:mt-10 mb-5 sm:mb-6">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-1.5 sm:h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentIndex
                    ? 'bg-sage-500 w-7 sm:w-8'
                    : 'bg-sage-200 w-1.5 sm:w-2 hover:bg-sage-300'
                }`}
              ></button>
            ))}
          </div>

          {/* Arrows */}
          <div className="flex justify-center gap-3">
            <button
              onClick={prevTestimonial}
              className="w-10 sm:w-11 h-10 sm:h-11 flex items-center justify-center bg-sage-50 hover:bg-sage-100 rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-sage-600 text-lg sm:text-xl"></i>
            </button>
            <button
              onClick={nextTestimonial}
              className="w-10 sm:w-11 h-10 sm:h-11 flex items-center justify-center bg-sage-50 hover:bg-sage-100 rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-sage-600 text-lg sm:text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
